import Vue from 'vue';
import Paginate from 'vuejs-paginate'

export default Vue.component('pagination', {
    template:`
        <div class="row">
            <div class="col-12 col-md-6">
                <div class="dataTables_info font-size-sm">
                    {{resources.pagination.showingText}}
                    <strong v-html="resultsFrom"/>
                    -
                    <strong v-html="resultsTo"/>
                    {{resources.pagination.ofText}}
                    <strong v-html="pagination.totalRecordCount"/>
                    {{resources.pagination.resultsText}}
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="dataTables_paginate paging_simple_numbers font-size-sm">
                    <paginate v-model="queryParameters.pageNumber" 
                        :page-count="pagination.totalPageCount"
                        :click-handler="performSearch"
                        :prev-text="previousPageText"
                        :next-text="nextPageText"
                        container-class="pagination"
                        page-class="paginate_button page-item"
                        page-link-class="page-link"
                        prev-class="paginate_button page-item previous"
                        prev-link-class="page-link"
                        next-class="paginate_button page-item next"
                        next-link-class="page-link"
                        :page-range="5"
                        :margin-pages="3">
                    </paginate>
                </div>
            </div>
        </div>
    `,
    components:{
        'paginate': Paginate
    },
    inject: [
        'performSearch'
    ],
    props:{
        pagination: Object,
        queryParameters: Object,
        resources: Object,
        loadingPaginationData: Boolean,
        rows: Array
    },
    computed: {
        previousPageText(){ 
            return '<i class="fa fa-angle-left"></i>' 
        },
        nextPageText(){
            return '<i class="fa fa-angle-right"></i>';
        },
        resultsFrom(){
            return this.pagination.totalRecordCount > 0 ? ((this.queryParameters.pageNumber - 1) * this.queryParameters.pageSize) + 1 : 0
        },
        resultsTo(){
            return Math.min(this.queryParameters.pageNumber * this.queryParameters.pageSize, this.pagination.totalRecordCount);
        }
    }
});